import { CHANGE_CLAIM_STATUS_PASSWORD } from './constants';

import type { ISelectOption } from '../../../utils/types';

// Returns helper text for the password field. An empty field shows nothing.
export const getChangeClaimStatusPasswordInfoText = (password: string): string => {
  if (password.length === 0) return '';
  return password === CHANGE_CLAIM_STATUS_PASSWORD ? 'Password verified' : 'Password does not match';
};

// Maps status/payment values to sorted, always-enabled dropdown options.
// Sort the strings first, then map, so no cast is needed (AGENTS.md bans `as`).
export const toSortedSelectOptions = (values: readonly string[]): ISelectOption[] =>
  [...values]
    .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
    .map((value) => ({ value, label: value }));
